export const environment = {
  production: true,
  apiHost: 'https://tcmbdata.culture.tw',
  allowBackStageDomain: ['https://tcmb.culture.tw'],
  recaptchaKey: '6Lc0oWghAAAAAGVMVHXeCEJv72mL2mXHO0O_9F5Q',
  commonToken: '8CC1C549-35D7-4691-9E1D-67D8EC7951B5',
  memberWeb: 'http://member.moc.gov.tw/MOCMC/T0001/list?SYS_ID=NMTH_TCMB',
  memberLogout: 'http://member.moc.gov.tw/MOCMC/M0003/logout?SYS_ID=NMTH_TCMB',
  itriSearchApiHost: 'https://searchapi.culture.tw',
  itriAutoCompleteApiHost: 'https://searchapi.culture.tw',
  googleSiteVerification: 'mgoHOnJ4weAiyCfwNQ9hLAQarx7oMxO16ZFj637-C3U',
};
